<div class="container-header">
  <div class="container-page-title">
    <h1>{{ title }}</h1>
  </div>
  <div class="container-user-actions">
    <div>
      <p-button *ngIf="swArticleTask" (click)="getArticleTaskPending(true)" variant="text" icon="pi pi-bell"
        [badge]="totalTasks > 0 ? totalTasks.toString() : ''" />
      <app-custom-modal *ngIf="swArticleTask" #articleTaskModal [label]="'Tareas pendientes por ejecutar'"
        [width]="'40rem'" [header]="'Tareas pendientes por ejecutar'" [children]="componentArticleTask"
        [inputs$]="inputsForArticleTask$" hidden> aaa
      </app-custom-modal>

      <p-button onkeypress="supportPopover.toggle($event)" (click)="supportPopover.toggle($event)" variant="text"
        icon="pi pi-headphones" />
    </div>
    <p-button styleClass="p-button-text pl-0 pr-0 pt-0 pb-0 p-0 border-0 border-white"
      onkeypress="profilePopover.toggle($event)" (click)="profilePopover.toggle($event)" variant="text">
      <div class="container-user-profile">
        <div class="user-name">
          <p>{{ userName }}</p>
          <p>{{ companyName }}</p>
        </div>
        <div class="user-avatar">
          {{ userInitials }}
        </div>
      </div>
    </p-button>
    <p-button onkeypress="logoutUser()" (click)="logoutUser()" variant="text" icon="pi pi-sign-out" />
  </div>
</div>

<p-popover #supportPopover>
  <div>
    <div class="border-bottom p-2 mb-3">
      <div class="d-flex items-center gap-2 mb-2 container-section-main">
        <i class="pi pi-headphones w-6 h-6 section-icon-main"></i>
        <h3 class="section-title-main">Soporte Técnico</h3>
      </div>
    </div>

    <div class="p-2 space-y-4 d-flex flex-column gap-2 container-section-text">
      <div class="d-flex items-center gap-3 border-bottom">
        <i class="pi pi-phone w-5 h-5 text-gray-500 section-icon"></i>
        <div>
          <p class="section-title">Teléfono de soporte</p>
          <p>(+57) 304 559 3974</p>
        </div>
      </div>
    </div>

    <div class="p-2 space-y-4 d-flex flex-column gap-2 container-section-text">
      <div class="d-flex items-center gap-3 border-bottom">
        <i class="pi pi-envelope w-5 h-5 text-gray-500"></i>
        <div>
          <p class="section-title">Email de soporte</p>
          <p>
            <a href="mailto:as.altos.software@gmail.com">
              as.altos.software&#64;gmail.com
            </a>
            <p-button onkeypress="copyEmailToClipboard()" class="section-copy-button" (click)="copyEmailToClipboard()"
              variant="text" icon="pi pi-copy" />
          </p>
        </div>
      </div>
    </div>

    <div class="p-2 space-y-4 d-flex flex-column gap-2 container-section-text">
      <div class="d-flex flex-column flex-items-center gap-1">
        <div class="d-flex items-center gap-3">
          <i class="pi pi-clock w-5 h-5 text-gray-500"></i>
          <p class="section-title">Horarios de Atención</p>
        </div>
        <div class="schedule-container">
          <div>
            <p class="text-sm font-large text-gray-600">Lunes a Viernes:</p>
            <p class="text-sm text-gray-600">7:30 AM - 12:00 PM</p>
            <p class="text-sm text-gray-600">1:00 PM - 5:00 PM</p>
          </div>

          <div>
            <p class="text-sm font-medium text-gray-600">Sábados:</p>
            <p class="text-sm text-gray-600">8:00 AM - 12:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-popover>

<p-popover #profilePopover>
  <div class="p-2 d-flex flex-column">
    <p-button (click)="openPasswordModal()" onkeypress="openPasswordModal()" variant="text"
      styleClass="p-button-text p-0 border-0 link-dark">
      <div class="d-flex items-center gap-3" class="profile-item">
        <i class="pi pi-key w-5 h-5 text-gray-500"></i>
        <div>
          <p>Cambiar contraseña</p>
        </div>
      </div>
    </p-button>
  </div>
</p-popover>
<app-custom-modal #updatePasswordUser [label]="'Actualizar Contraseña'" [header]="'Actualizar Contraseña'"
  [children]="updatePasswordComponent" [width]="'25vw'" hidden>